module.exports = __webpack_public_path__ + "img/me-aside.e700e49d.jpg";